// src/services/http.js
import {
  getAccessToken,
  saveSession,
  loadSession,
  clearSession,
} from "../auth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

async function refreshAccessToken() {
  const res = await fetch(`${API_URL}/auth/refresh`, {
    method: "POST",
    credentials: "include", // send refresh cookie
  });
  if (!res.ok) throw new Error("Refresh failed");
  const { access_token } = await res.json();
  const session = loadSession() || {};
  session.accessToken = access_token;
  saveSession(session);
  return access_token;
}

export async function authFetch(path, options = {}) {
  const url = path.startsWith("http") ? path : `${API_URL}${path}`;
  const token = getAccessToken();

  const tryOnce = async (tokenToUse) => {
    const isFormData = options?.body instanceof FormData;

    // Build headers: do NOT set Content-Type if sending FormData (browser will set the boundary)
    const baseHeaders = {
      ...(options.headers || {}),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(tokenToUse ? { Authorization: `Bearer ${tokenToUse}` } : {}),
    };
    if (!isFormData && !("Content-Type" in baseHeaders)) {
      baseHeaders["Content-Type"] = "application/json";
    }

    const res = await fetch(url, {
      ...options,
      headers: baseHeaders,
      credentials: "include",
    });
    return res;
  };

  let res = await tryOnce(token);

  // If access token expired, refresh and retry once
  if (res.status === 401) {
    try {
      const newToken = await refreshAccessToken();
      res = await tryOnce(newToken);
    } catch {
      clearSession();
      window.location.assign("/login");
      throw new Error("Session expired. Please log in again.");
    }
  }
  return res;
}
